export const FLAG_GETTING_LEGAL_MANIFEST_CARGOS = 'FLAG_GETTING_LEGAL_MANIFEST_CARGOS';
export const GET_LEGAL_MANIFEST_CARGOS = 'GET_LEGAL_MANIFEST_CARGOS';
export const CLEAR_LEGAL_MANIFEST_CARGOS = 'CLEAR_LEGAL_MANIFEST_CARGOS';
export const FLAG_LEGAL_MANIFEST_CARGO_ACTIVITY = 'FLAG_LEGAL_MANIFEST_CARGO_ACTIVITY';
export const GET_LEGAL_MANIFEST_CARGO = 'GET_LEGAL_MANIFEST_CARGO';
export const CLEAR_LEGAL_MANIFEST_CARGO = 'CLEAR_LEGAL_MANIFEST_CARGO';
